import { useTitle } from "@/Utilities/Hooks";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Inertia } from "@inertiajs/inertia";
import React, { useEffect, useState } from "react";
import { LabeledInput, LabeledSelect } from "@/Components/Form";
import { FormError, Formheader } from "@/Components";
import { toast } from "react-toastify";
import LayoutIcon from "@/Components/LayoutIcon";
import { Users as UsersIcon } from "@/Icons";

export default function Invite({ roles, errors, auth }) {
  const errorBagKey = "inviteUsers";

  let roles_options = Object.keys(roles).reduce((p, c) => {
    return [...p, { label: roles[c], value: c }];
  }, []);

  const [defaultRole, setDefaultRole] = useState(
    roles_options.find((option) => option.label === "Reporter") || null,
  );

  let [values, setValues] = useState({
    emails: "",
    role: defaultRole.value || "",
  });

  useEffect(() => {
    setDefaultRole(
      roles_options.find((option) => option.value === values.role),
    );
  }, [values.role]);

  function handleSave(e) {
    e.preventDefault();
    const id = toast.loading("Please wait...");

    Inertia.post(`/users/invite`, values, {
      onSuccess: (result) => {
        toast.update(id, {
          render: "The users were successfully invited!",
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
        });
        Inertia.visit("/users");
      },
      onError: () => {
        toast.update(id, {
          render: "An error occurred while inviting the users",
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
        });
      },
    });
  }

  function handleUpdate(event) {
    setValues((prevValues) => {
      return { ...prevValues, [event.target.name]: event.target.value };
    });
  }

  function SettingsSaveButton() {
    return <button className="btn ml-3 self-end">Send invite</button>;
  }

  return (
    <>
      <form onSubmit={handleSave}>
        <div className="shadow-small flex flex-row flex-wrap bg-gray-light px-8 py-6">
          <div className="w-full">
            <Formheader>User details</Formheader>
          </div>

          <div className="mb-4 w-full md:mb-0 md:w-5/6 md:pr-4">
            <LabeledInput
              title="E-mail"
              name="emails"
              type="text"
              placeholder="Enter comma separated e-mail addresses"
              value={values.email}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.email} />
          </div>

          <div className="flex w-full md:mb-0 md:w-1/6">
            <div className="mb-4 w-full">
              <LabeledSelect
                title="Role"
                name="role"
                noDefault={true}
                defaultOption={defaultRole.label}
                defaultValue={defaultRole.value}
                options={roles_options.reverse()}
                onChange={handleUpdate}
              />
              <FormError error={errors && errors[errorBagKey]?.role} />
            </div>
          </div>
        </div>

        <div className="mt-4 flex w-full  justify-end">
          <SettingsSaveButton />
        </div>
      </form>
    </>
  );
}

Invite.layout = (page) => (
  <AppLayout title="Invite users">
    <OrganizationLayout
      header="Invite users"
      backAction={{ label: "Back", callback: () => Inertia.visit("/users") }}
      icon={
        <LayoutIcon>
          <UsersIcon size={40} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
